<template>
  <div class="animated fadeIn">
    <b-row class="mb-4">
        <b-col sm="12" lg="12" >
            <h3 class="pull-left mb-0">Settings</h3>
             <b-button class="pull-right" variant="primary" >Save</b-button>
        </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" lg="12">
        <b-card no-body >
          <b-card-body class="pb-0">
            
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>


export default {
  name: 'settings',
  components: {
  
  },
  data: function () {
    return {
      
    }
  },
  methods: {

  }
}
</script>

<style>

</style>
